//react
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import sha256 from 'crypto-js/sha256';

//data
import dataSiteMap from '../../siteMap.json';
import dataTranslations from './translations.json';

//assets
import './popup.css';

class PopupLogin extends Component {
	constructor() {
		super();

		this.state = {
			loggedIn: false,
			loginFail: false,
			stageIndex: 0,
		};

		this.login = this.login.bind(this);
		this.loginFail = this.loginFail.bind(this);
	}

	componentDidMount() {
		this.refs.username.focus();
	}

	login(event) {
		if (this.refs.username.value === '' && this.refs.password.value === '') {
			event.preventDefault();
			this.loginFail();
		} else if (!dataTranslations.login[this.props.culture][this.state.stageIndex].docCheckAccountId) {
			event.preventDefault();

			const hashKey1 = sha256(this.refs.username.value).toString();
			const hashKey2 = sha256(this.refs.password.value).toString();

			if (hashKey1 === dataSiteMap[this.props.culture].hcpLogin[this.state.stageIndex].key1 && hashKey2 === dataSiteMap[this.props.culture].hcpLogin[this.state.stageIndex].key2) {
				if (dataSiteMap[this.props.culture].hcpLogin.length === this.state.stageIndex + 1) {
					window.sessionStorage.setItem(this.props.culture + 'Key1', sha256(hashKey1).toString());
					window.sessionStorage.setItem(this.props.culture + 'Key2', sha256(hashKey2).toString());

					this.setState({
						loggedIn: true,
					});
				} else {
					this.setState({
						stageIndex: this.state.stageIndex + 1,
					});

					this.refs.username.value = '';
					this.refs.password.value = '';
					this.refs.username.focus();
				}
			} else {
				this.loginFail();
			}
		}
	}

	loginFail() {
		const _this = this;

		this.setState({
			loginFail: false,
		});

		setTimeout(function() {
			_this.setState({
				loginFail: true,
			});
		}, 250);
	}

	render() {
		if (this.state.loggedIn) {
			return (
				<Redirect to={this.props.url} />
			);
		}

		const culture = this.props.culture;
		const docCheckAccountId = dataTranslations.login[culture][this.state.stageIndex].docCheckAccountId;
		let formAction = "";
		let legendClass = 'popup__legend';
		let popupShakeClass = '';

		if (docCheckAccountId) {
			formAction = "https://login.doccheck.com";
			legendClass = legendClass + ' ' + legendClass + '--docCheck';
		}

		if (this.state.loginFail) {
			popupShakeClass = 'popup__shake';
		}

		return (
			<div className="popup">
				<div className={popupShakeClass}>
					<form action={formAction} className="popup__inner" method="post" onSubmit={(event) => this.login(event)}>
						<legend className={legendClass}>
							{dataTranslations.login[culture][this.state.stageIndex].title}
						</legend>
						{dataTranslations.login[culture][this.state.stageIndex].helpLink &&
							<a className="popup__help" href={dataTranslations.login[culture][this.state.stageIndex].helpLink} rel="noopener noreferrer" target="_blank">i</a>
						}
						{dataTranslations.login[culture][this.state.stageIndex].body &&
							<p>{dataTranslations.login[culture][this.state.stageIndex].body}</p>
						}
						<div>
							<label htmlFor="username">{dataTranslations.login[culture][this.state.stageIndex].username}</label>
							<input id="username" name="username" ref="username" type="text" />
						</div>
						<div>
							<label htmlFor="password">{dataTranslations.login[culture][this.state.stageIndex].password}</label>
							<input id="password" name="password" ref="password" type="password" />
						</div>
						<button className="popup__button hwa">{dataTranslations.login[culture][this.state.stageIndex].submit}</button>
						<button className="popup__button popup__button--close hwa" onClick={(event) => this.props.close(event, true)}>{dataTranslations.login[culture][this.state.stageIndex].close}</button>
						<div className="popup__link-list">
							{dataTranslations.login[culture][this.state.stageIndex].forgottenPasswordLink && dataTranslations.login[culture][this.state.stageIndex].forgottenPasswordLabel &&
								<div className="popup__link-list__item">
									<a href={dataTranslations.login[culture][this.state.stageIndex].forgottenPasswordLink} rel="noopener noreferrer" target="_blank">{dataTranslations.login[culture][this.state.stageIndex].forgottenPasswordLabel}</a>
								</div>
							}
							{dataTranslations.login[culture][this.state.stageIndex].registerLink && dataTranslations.login[culture][this.state.stageIndex].registerLabel &&
								<div className="popup__link-list__item">
									<a href={dataTranslations.login[culture][this.state.stageIndex].registerLink} rel="noopener noreferrer" target="_blank">{dataTranslations.login[culture][this.state.stageIndex].registerLabel}</a>
								</div>
							}
						</div>
						{docCheckAccountId &&
							<div>
								<input type="hidden" name="login_id" value={docCheckAccountId}/>
								<input type="hidden" name="strDcLanguage" value={culture} />
								<input type="hidden" name="dc_iframe_referer" value="" />
								<input type="hidden" name="intDcLanguageId" value={dataTranslations.login[culture][this.state.stageIndex].docCheckLanguageId} />
								<input type="hidden" name="intLoginVersion" value="3" />
								<input type="hidden" name="strDesignVersion" value="xl_red" />
								<input type="hidden" name="intLogoutSwitch" value="0" />
							</div>
						}
					</form>
				</div>
			</div>
		);
	}
}

export default PopupLogin;



// WEBPACK FOOTER //
// ./src/components/popup/login.js